const $marketSelectorBar = $('.market-selector-bar');
const $marketSelectorBarCloseButton = $('.js-market-selector-bar-close-button');

const closeMarketSelectorBar = () => {
    $marketSelectorBar.slideUp("slow");
}

const events = () => {
    $marketSelectorBarCloseButton.on('click', closeMarketSelectorBar);
}

const init = () => {
    events();
}

export default init;
